// Tracks the realtime-gateway socket connection so the page can show the "SAM is offline" banner
// and block sends while disconnected.
import { useEffect, useState } from 'react';
import { socketService } from '@/services/SocketService';

export function useSocketStatus(): boolean {
  const [connected, setConnected] = useState(socketService.isConnected);
  useEffect(() => {
    const onConnect = () => setConnected(true);
    const onDisconnect = () => setConnected(false);
    socketService.on('connect', onConnect);
    socketService.on('disconnect', onDisconnect);
    return () => {
      socketService.off('connect', onConnect);
      socketService.off('disconnect', onDisconnect);
    };
  }, []);
  return connected;
}
